export default __webpack_public_path__ + "static/media/auth-image.ac0ff888.jpg";